import { BellSimpleSlash } from 'phosphor-icons';
import { c } from '../../../utils/tailwind-merge';
import { NotificationEmptyContentProps } from './NotificationEmptyContent.types';

export const NotificationEmptyContent = ({
  microcopy,
  className = '',
}: NotificationEmptyContentProps) => {
  return (
    <div
      className={c(
        'flex h-full w-full flex-col items-center justify-center gap-3 bg-grey-900',
        className
      )}
    >
      <BellSimpleSlash className="h-8 w-8 text-grey-100" aria-hidden />
      <div className="flex w-72 flex-col items-center gap-1 text-center text-sm leading-5 tracking-[-0.004px]">
        <p className="font-semibold text-grey-100">{microcopy.title}</p>
        <p className="text-grey-400">{microcopy.description}</p>
      </div>
    </div>
  );
};
